module.exports = __webpack_public_path__ + "img/m7.8a6b510d.png";